import { Component } from 'react'
import qs from 'query-string'
import i18n from '../i18n'

import axios from "axios"
import { GetBaseUrl, GetDefaultUrl } from '@/utils/ConfigHelper'
import { TrackingVideo09Contact } from '@/utils/AnalyticsHelper'
import * as LastViewTemplateHelper from '@/utils/LastViewTemplateHelper'
import { InitLanguage } from '@/utils/LangHelper'
import * as ChannelIO from '@/utils/ChannelIO'
import {
    REDUX_ACTION
} from '@/Redux/action'
import { ReduxBinding } from '@/Redux/instance'
import { connect } from 'react-redux'
import { IsDevAndLocal } from '@/utils/Global'
import DataManager from '@/utils/DataManager'
import { CreditsApis, MySourceApis } from "@/utils/Videomonster/Apis"

let self

class InterfaceComponent extends Component {
    async componentDidMount() {
        self = this

        let body = document.getElementsByTagName("body")[0]
        let commentArea = document.getElementById("commentArea")
        commentArea && commentArea.classList.add("scroll")
        body.classList.add("scroll")

        const root = document.getElementById("root")
        if (root) root.style.setProperty('min-width', '1426px')

        InitLanguage()

        let token = DataManager.GetToken();
        let refreshtoken = DataManager.GetRefreshToken();
        
        const queryStringObj = qs.parse(window.location.search, { ignoreQueryPrefix: true })
        const provider = DataManager.GetProvider();
        const { VIDEO09 } = DataManager.PROVIDER;
        if ((DataManager.IsProvider(VIDEO09) || queryStringObj.provider === VIDEO09)) {
            if (queryStringObj.cafe24) {
                const { bdom, mid, email, shopname } = queryStringObj;
                const data = JSON.stringify({ bdom, mid, email, shopname })
                DataManager.CryptoStorage.SetSessionItem("vUserData", data)
            }
            // process.nextTick(this.InitChannelIO);
            if (Object.keys(queryStringObj).length) window.history.replaceState(null, null, `${window.location.origin}${window.location.pathname}`);
            return;
        }

        // query string에서 parameter들을 가져옵니다.
        if (queryStringObj.recommender) sessionStorage.setItem("recommenderSession", queryStringObj.recommender)
        if (queryStringObj.coupon_code) sessionStorage.setItem("couponCode", queryStringObj.coupon_code)
        if (typeof document.referrer === 'string' && document.referrer.toLowerCase().includes("gettyimagesbank.com")) {
            sessionStorage.setItem("recommenderSession", "GETTYIMAGESBANK")
            queryStringObj.recommender = "GETTYIMAGESBANK"
        }
    
        if (provider === "cafe24" || queryStringObj.provider === "cafe24") {
            if (queryStringObj.token) token = queryStringObj.token;
            if (queryStringObj.refreshtoken) refreshtoken = queryStringObj.refreshtoken;
            
            if (IsDevAndLocal() && queryStringObj.test) {
                alert("테스트 계정으로 접속함")
                DataManager.SetCafe24AccessToken("TEST_CAFE24_ACCESS_TOKEN", "2099-09-26T16:46:25.000")
                DataManager.SetCafe24RefreshToken("TEST_CAFE24_REFRESH_TOKEN", "2099-09-26T16:46:25.000")
            }
            else {
                if (queryStringObj.cftoken) DataManager.SetCafe24AccessToken(queryStringObj.cftoken, queryStringObj.expiresAt)
                if (queryStringObj.cfrefreshtoken) DataManager.SetCafe24RefreshToken(queryStringObj.cfrefreshtoken, queryStringObj.refreshTokenExpiresAt)
            }
        }

       
        
        if (Object.keys(queryStringObj).length > 0) {
            const obj = { ...JSON.parse(JSON.stringify(queryStringObj)) }
            delete obj.token
            delete obj.refreshtoken
            delete obj.cfrefreshtoken
            delete obj.cftoken
            delete obj.coupon_code
            localStorage.setItem("trackingData", JSON.stringify(obj))
        }

        if (token || refreshtoken || queryStringObj.token || queryStringObj.refreshtoken) {
            ReduxBinding(REDUX_ACTION.USER, {})
        }

        // localStorage에 토큰 또는 리프레시토큰이 없을 경우, query string에서 값을 가져옵니다.
        if (!token) token = queryStringObj.token
        if (!refreshtoken) refreshtoken = queryStringObj.refreshtoken

        const creditsProducts = await CreditsApis.GetCreditsProducts(token);
        const response = await MySourceApis.GetMySourceCapacity(token);
        ReduxBinding(REDUX_ACTION.CREDITS_PRODUCTS_STATE, creditsProducts.data);
        if(response.result) {
            const { totalCapacity, usedCapacity } = response.data
            ReduxBinding(REDUX_ACTION.WORKSPACE_CAPACITY_STATE, {
                total: totalCapacity,
                used: usedCapacity,
            });
        }
        if (refreshtoken) {
            let jwtLoginResult = null
            let isError = false

            // 기존 토큰이 있을 경우 JWTLogin 시도
            if (token) {
                try {
                    jwtLoginResult = await GetJWTToken(token)
                }
                catch (e) {
                    if (!(e && e.response && e.response.status === 401)) isError = true
                }
            }
            if (isError) return

            let refreshResult = null
            isError = false
            try {
                // JwtLogin을 성공했을 경우 리프레시토큰만 재발급, 실패했을 경우 토큰 & 리프레시토큰 둘 다 발급
                refreshResult = await UpdateRefreshToken(refreshtoken, jwtLoginResult ? 'refreshonly' : 'all')
                // JwtLogin을 실패하고 토큰을 다시 재발급 받았을 경우 JwtLogin을 다시 수행
                if (!jwtLoginResult && refreshResult) jwtLoginResult = await GetJWTToken(refreshResult.token)
            }
            catch (e) {
                if (!(e && e.response && e.response.status === 401)) isError = true
            }

            if (isError) return

            if (refreshResult && jwtLoginResult) {
                const { refreshtoken } = refreshResult
                const { userId: _id, displayName, shareId, email, createdAt, admin, type, token: newToken, agreement, lang, provider } = jwtLoginResult

                const userData = {
                    _id,
                    userId: displayName,
                    shareId,
                    displayName,
                    email,
                    createdAt,
                    admin,
                    type,
                    lang,
                    provider,
                    agreement
                }
                if (type === "cafe24" && provider && provider.cafe24) {
                    DataManager.SetProvider(DataManager.PROVIDER.CAFE24)
                    sessionStorage.setItem("mid", provider.cafe24.mallId);
                }

                onUserLoggedIn(userData, newToken, refreshtoken)
                if (agreement) {
                    if (queryStringObj.token || queryStringObj.refreshtoken) {
                        this.props.history.replace('/')
                    }
                }
                else {
                    this.props.history.push('/requiredBox')
                }
            }
            else onUserLoggedOut()
        }
        else onUserLoggedOut()

        process.nextTick(this.InitChannelIO)
    }

    componentDidUpdate(prevProps) {
        const { lang } = this.props
        if (prevProps.lang !== lang) {
            if (lang !== 'ko') {
                ChannelIO.Shutdown()
            }
            else {
                this.InitChannelIO()
            }
        }
    }

    InitChannelIO = async () => {
        const { lang, currentUser } = this.props
        if (lang !== 'ko') return

        await ChannelIO.Initialize()
        ChannelIO.Boot(currentUser)
        const spot = sessionStorage.getItem("spot");
        if (!DataManager.IsProvider(DataManager.PROVIDER.VIDEO09) || !spot) return;
        window.ChannelIO('onChatCreated', function onChatCreated() {
            TrackingVideo09Contact(spot)
        });
    }

    render() {
        return null
    }
}

export const GetJWTToken = async token => {
    try {
        const jwtResponse = await axios.get(`${GetBaseUrl()}/api/auth/jwtLogin`, {
            headers: { Authorization: `Bearer ${token}` }
        })
        if (jwtResponse && jwtResponse.data) {
            return jwtResponse.data
        }
    }
    catch (e) {

    }
    return null
}

const UpdateRefreshToken = async (refreshtoken, option) => {
    let queryStr = ''
    if (option === 'all' || option === 'refreshonly') queryStr = `?options=${option}`

    try {
        const response = await axios.get(`${GetBaseUrl()}/api/auth/refresh-token${queryStr}`, {
            headers: { Authorization: `Bearer ${refreshtoken}` }
        })

        if (response && response.data) {
            return response.data
        }
    }
    catch (e) {

    }
    return null
}

export const onUserLoggedIn = async (loggedInUserData, token, refreshtoken) => {
    DataManager.SetToken(token);
    DataManager.SetRefreshToken(refreshtoken)
    
    await LastViewTemplateHelper.SaveLastViewTemplateToServerFromLocal()

    const userProfile = await GetUserProfileURL(loggedInUserData._id)
    const credits = await CreditsApis.GetCurrentUserCredits(token);
    ReduxBinding(REDUX_ACTION.CREDITS_STATE, credits.data.totalUsableCredit);
    ReduxBinding(REDUX_ACTION.MY_PROFILE_URL_STATE, userProfile)
    ReduxBinding(REDUX_ACTION.USER, loggedInUserData)
    ReduxBinding(REDUX_ACTION.GALLERY_STATE, undefined)

    ChannelIO.Boot(loggedInUserData)

    FetchLikeTemplates()
    FetchLastViewTemplates()
    FetchPaymetMode()
    FetchPointTicket()
    FetchPoint()
    FetchCoupons()
    FetchAccountStatus()
    FetchBlockUserList()
}

const onUserLoggedOut = async(redirectPath) => {
    const provider = DataManager.GetProvider();
    const token = DataManager.GetToken();
    const refreshtoken = DataManager.GetRefreshToken();
    await axios.delete(`${GetBaseUrl()}/api/auth/logout?refreshtoken=${refreshtoken}`, { headers: { Authorization: `Bearer ${token}` } }).catch(() => { })
  
    ReduxBinding(REDUX_ACTION.USER, undefined)
    ReduxBinding(REDUX_ACTION.GALLERY_STATE, undefined)

    ReduxBinding(REDUX_ACTION.LIKE_TEMPLATES, [])
    ReduxBinding(REDUX_ACTION.LASTVIEW_TEMPLATES, LastViewTemplateHelper.GetLastViewTemplateFromLocal())
    ReduxBinding(REDUX_ACTION.PAYMENT_MODE, {})
    ReduxBinding(REDUX_ACTION.COUPON_STATE, [])
    ReduxBinding(REDUX_ACTION.ACCOUNTSTATUS_STATE, {})
    ReduxBinding(REDUX_ACTION.BLOCK_USERS, [])
	ReduxBinding(REDUX_ACTION.CREDITS_STATE, null);
    ReduxBinding(REDUX_ACTION.WORKSPACE_CAPACITY_STATE, {
        total: 0,
        used: 0,
    });
    DataManager.ClearAllToken();
    if (provider === DataManager.PROVIDER.CAFE24) {
        const pathname = self.props.history.location.pathname;
        const path = redirectPath ? redirectPath : "/login";
        if ((pathname !== "/" && pathname !== "/home" && pathname !== "/login") || redirectPath) HistoryPush(path);
    }
    else {
        const pathname = self.props.history.location.pathname;
        let path;
        switch (pathname) {
            case "/socialnotfound":
            case "/socialwithdraw": 
                path = `${pathname}`;
                break;
            case "/Privacy":
            case "/privacy":
            case "/Tos":
            case "/tos":
            case "/Copyright":
            case "/copyright":
            case "/ai-product-term":
            case "/delete-account-guide":
                /*
                    NOTE : 24.02.28

                    로그아웃된 상태에서 URL을 통해 다이렉트로 해당 페이지들에 접근하려고하면 home 화면이 열림.
                    Facebook에서 공개적으로 접근 가능한 개인정보처리방침 URL이 유효하지 않다고 경고를 받음.
                        
                    ref: https://developers.facebook.com/terms/dfc_platform_terms/#privacypolicy
                */
                path = pathname;
                break;
            default: 
                path = redirectPath ? redirectPath : "/"; 
                break;
        }
        HistoryPush(path);
    }

}

export const Login = async (email, password) => {
    const response = await axios.post(`${GetBaseUrl()}/api/auth/login`, {
        id: email,
        pw: password
    })

    const { success } = response.data
    if (success) {
        const { userId: _id, displayName, shareId, email, createdAt, type, admin, token, refreshtoken, lang } = response.data
        const userData = {
            _id,
            userId: displayName,
            displayName,
            shareId,
            email,
            createdAt,
            admin,
            type,
            lang
        }
        onUserLoggedIn(userData, token, refreshtoken)
    }
}

let isFetchLikeTemplates = false
export const FetchLikeTemplates = async () => {
    if (isFetchLikeTemplates) return
    isFetchLikeTemplates = true

    const token = DataManager.GetToken();
    try {
        const response = await axios.get(`${GetBaseUrl()}/api/user/like-template-names`, { headers: { Authorization: `Bearer ${token}` } })
        ReduxBinding(REDUX_ACTION.LIKE_TEMPLATES, Array.isArray(response.data) ? response.data.map(item => item.groupName) : [])
    }
    catch (e) {

    }
    isFetchLikeTemplates = false
}

let isFetchLastViewTemplates = false
export const FetchLastViewTemplates = async () => {
    if (isFetchLastViewTemplates) return
    isFetchLastViewTemplates = true

    const token = DataManager.GetToken();
    try {
        const response = await axios.get(`${GetBaseUrl()}/api/user/last-view-templates`, { headers: { Authorization: `Bearer ${token}` } })
        ReduxBinding(REDUX_ACTION.LASTVIEW_TEMPLATES, Array.isArray(response.data) ? response.data : [])
    }
    catch (e) {

    }
    isFetchLastViewTemplates = false
}

let isFetchPaymetMode = false
export const FetchPaymetMode = async () => {
    if (isFetchPaymetMode) return
    isFetchPaymetMode = true
    // const provider = sessionStorage.getItem("provider");
    const token = DataManager.GetToken();
    try {
        // if (provider === "cafe24") {
        //     const cftoken = await DataManager.GetCafe24AccessToken();
        //     await PaymentApis.PostCafe24VerifyTicket(token, { cftoken });
        // }

        const [
            { data: { data: paymentMode } },
            { data: { data: { list: payments } } }
        ] = await Promise.all([
            axios.get(`${GetBaseUrl()}/apis/payments/current-ticket`, { headers: { Authorization: `Bearer ${token}` } }),
            axios.get(`${GetBaseUrl()}/apis/payments`, { headers: { Authorization: `Bearer ${token}` } })
        ])
        ReduxBinding(REDUX_ACTION.PAYMENT_MODE, paymentMode)
        ReduxBinding(REDUX_ACTION.PAYMENTS, payments)
    
        const validPaymentType = { PerPayment: true, ChargeSubscription: true, ScheduledSubscription: true, TermPayment: true }
        let isPaid = false
        for (let i=0; i<payments.length; i++) {
            if (validPaymentType[payments[i].type]) {
                isPaid = true
                break
            }
        }
        ChannelIO.AddProfileKey({ isPaid })
    }
    catch (e) {

    }
    isFetchPaymetMode = false
}

let isFetchPoint = false
export const FetchPoint = async () => {
    if (isFetchPoint) return
    isFetchPoint = true

    const token = DataManager.GetToken();
    try {
        const response = await axios.get(`${GetBaseUrl()}/apis/point/current-point`, { headers: { Authorization: `Bearer ${token}` } })
        ReduxBinding(REDUX_ACTION.POINT, response.data.data.point)
    }
    catch (e) {

    }
    isFetchPoint = false
}

let isFetchPointTicket = false
export const FetchPointTicket = async () => {
    if (isFetchPointTicket) return
    isFetchPointTicket = true

    const token = DataManager.GetToken();
    try {
        const response = await axios.get(`${GetBaseUrl()}/apis/point/current-ticket`, { headers: { Authorization: `Bearer ${token}` } })
        ReduxBinding(REDUX_ACTION.POINT_TICKET, response.data.data)
    }
    catch (e) {

    }
    isFetchPointTicket = false
}

let isFetchCoupons = false
export const FetchCoupons = async () => {
    if (isFetchCoupons) return
    isFetchCoupons = true

    const token = DataManager.GetToken();
    try {
        const response = await axios.get(`${GetBaseUrl()}/apis/coupons/issued`, { headers: { Authorization: `Bearer ${token}` } });
        ReduxBinding(REDUX_ACTION.COUPON_STATE, response.data.data)
    }
    catch (e) {

    }
    isFetchCoupons = false
}

let isFetchAccountStatus = false
export const FetchAccountStatus = async () => {
    if (isFetchAccountStatus) return
    isFetchAccountStatus = true

    const token = DataManager.GetToken();
    try {
        const response = await axios.get(`${GetBaseUrl()}/api/user/getaccountstatus`, { headers: { Authorization: `Bearer ${token}` } })
        ReduxBinding(REDUX_ACTION.ACCOUNTSTATUS_STATE, {
            isDownloadable: response.data.isDownloadable,
            isEditable: response.data.isEditable,
            isExpiredFreePeriod: response.data.isExpiredFreePeriod
        })
    }
    catch (e) {

    }
    isFetchAccountStatus = false
}

export const Logout = onUserLoggedOut

export const GetUserProfileURL = async userId => {
    const token = DataManager.GetToken();

    try {
        let imgURL

        const result = await axios.get(`${GetBaseUrl()}/apis/users/${userId}/profile`,
            {
                headers: { Authorization: `Bearer ${token}` }
            }
        )

        if(result.data.data.url === '' || !result || !result.data || !result.data.data || !result.data.data.url) imgURL = 'baseImg'
        else imgURL = result.data.data.url

        return imgURL
    }
    catch (e) {
        return undefined
    }
}

export const SetUserProfileURL = async (file, _id, setUploadingAnimStateFunc) => {
    const token = DataManager.GetToken();
    try {
        setUploadingAnimStateFunc(true)
        const form = new FormData()
        form.append('source', file)

        await axios.post(`${GetDefaultUrl()}/apis/users/profile/upload`, form,
            { headers: { Authorization: `Bearer ${token}` } })
        const userProfile = await GetUserProfileURL(_id)
        ReduxBinding(REDUX_ACTION.MY_PROFILE_URL_STATE, userProfile)
        setUploadingAnimStateFunc(false)
    }
    catch (e) {
        setUploadingAnimStateFunc(false)
        alert(i18n.t('web.set.profile.error.message'))
        console.log(e)
    }
}

export const ResetUserProfile = async () => {
    const token = DataManager.GetToken();
    try {
        await axios.delete(`${GetDefaultUrl()}/apis/users/profile`,
            { headers: { Authorization: `Bearer ${token}` } })

        ReduxBinding(REDUX_ACTION.MY_PROFILE_URL_STATE, 'baseImg')
    }
    catch (e) {
        console.log(e)
    }
}

export const FetchBlockUserList = async () => {
    const token = DataManager.GetToken();
    const config = { headers: { Authorization: `Bearer ${token}` } }

    try {
        const response = await axios.get(`${GetBaseUrl()}/apis/users/block-users`, config)
        const { list } = response.data.data

        const blockedUserMap = {}
        list.forEach(item => blockedUserMap[item.userid] = item)

        ReduxBinding(REDUX_ACTION.BLOCK_USERS, blockedUserMap)
    } catch (e) {
        console.log(e)
        return 
    }
}

export const SetIsShowLoginDialog = value => ReduxBinding(REDUX_ACTION.LOGIN_POPUP_SHOW_STATE, value)
export const SetIsShowSignUpDialog = value => ReduxBinding(REDUX_ACTION.SIGNUP_POPUP_SHOW_STATE, value)

export const HistoryPush = path => self.props.history.push(path)
export const GetHistory = () => self.props.history

export const UpdateCurrentCredit = async () => {
    try {
        let token = DataManager.GetToken();
        if (!token) return
    
        const credits = await CreditsApis.GetCurrentUserCredits(token);
        ReduxBinding(REDUX_ACTION.CREDITS_STATE, credits.data.totalUsableCredit);
    }
    catch (e) {
        console.log(e)
    }
}

export const UpdateWorkspaceCapacity = async () => {
    try {
        const token = DataManager.GetToken();
        if (!token) return

        const response = await MySourceApis.GetMySourceCapacity(token);
        if (!response.result) return
        
        const { totalCapacity, usedCapacity } = response.data
        ReduxBinding(REDUX_ACTION.WORKSPACE_CAPACITY_STATE, {
            total: totalCapacity,
            used: usedCapacity,
        });
    }
    catch (e) {
        console.log(e)
    }
}

const mapStateToProps = state => ({
    lang: state.langStore.lang,
    currentUser: state.userStore.user
})

export const Interface = connect(mapStateToProps, null)(InterfaceComponent)
